module.exports = __webpack_public_path__ + "media/images/vp/mobileapps.android-92a940f44c4682fc0f51fe7cb3537d03.svg";